module.exports = __webpack_public_path__ + "assets/img/lpbao_09.74127723.jpg";